import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-radio-button',
  templateUrl: './radio-button.component.html',
  styleUrls: ['./radio-button.component.scss']
})
export class RadioButtonComponent {
  @Input() control!: FormControl;
  @Input() options: any[] = [];
  @Input() labelProperty: string = "label";
  @Input() valueProperty: string = "value";
  @Input() submitted: boolean = false;
  @Input() errorMessage: string = "";
  @Output() optionChanged = new EventEmitter<string>();

  onOptionChange(option: string) {
    this.optionChanged.emit(option);
  }
}
